import { PropsWithChildren } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { useEffect } from 'react';
import ServerError from "../ServerError/ServerError";

type ErrorProps = {};

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {

  useEffect(() => {
    window.clientLogger.error("Rendering Error",error)      
  }, [error]);

  return <ServerError status={422} />;
}

export const CustomErrorBoundary = (props: PropsWithChildren<ErrorProps>) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      {props.children}
    </ErrorBoundary>
  );
};
